
<template lang="pug">
  .employee-discount
</template>

<script>
  export default {
    name: 'EmployeeDiscount',
    props: {
      discountCode: String,
      emailDomains: Array,
    },
    mounted() {
      this.$store.dispatch('storefront/initEmployeeDiscount', {
        discountCode: this.discountCode,
        emailDomains: this.emailDomains,
      });
    },
  };
</script>

<style scoped lang="scss">
</style>